export const skillfulsimmer340ModsTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('SkillfulSimmer340') !== -1) {
			return {
				type: 'SkillfulSimmer340Test',
				color: 'IndianRed',
				title: 'Outdated mods by SkillfulSimmer340',
				text: 'You\'re using an outdated mod made by SkillfulSimmer340.',
				description: 'Remove all files related to the <strong>SkillfulSimmer340</strong> creator.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>3d0bfa6563925a145ba5e81b</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4.15.mac</sku>
        <createtime>2018-09-22 15:00:22</createtime>
        <buildsignature>Local.Unknown.Unknown.1.46.18.1220-1.200.000.364.Release</buildsignature>
        <categoryid>resolver.py:613</categoryid>
        <desyncid>3d0bfa6563925a145ba5e81b</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception when applying action &lt;StatisticSetMaxOp: SkillfulSimmer340_Homewrecker_Homewrecker_4EjW4xsmr maximum&gt; for loot &lt;class 'sims4.tuning.instances.SkillfulSimmer340_Homewrecker_Homewrecker_pEIOzhLyzgp'&gt; (ValueError: Trying to use SingleSimResolver with unsupported participant: ParticipantType.Invalid)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 205, in c_api_server_tick
  File &quot;.\WickedWhims 3.3.4.133b\turbolib\injector_util.py&quot;, line 21, in _wrapped_function
  File &quot;.\WickedWhims 3.3.4.133b\turbolib\events\core_tick.py&quot;, line 102, in _turbolib_zone_game_update
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 464, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\time_service.py&quot;, line 112, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 212, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\alarms.py&quot;, line 260, in _run
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\continuous_statistic.py&quot;, line 725, in _alarm_callback
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\continuous_statistic.py&quot;, line 746, in _trigger_callback
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\base_statistic_listener.py&quot;, line 53, in trigger_callback
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\commodity.py&quot;, line 1020, in _update_state_down
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\commodity.py&quot;, line 1261, in _set_state
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot.py&quot;, line 373, in apply_to_resolver
  File &quot;.\WickedWhims 3.3.4.133b\turbolib\injector_util.py&quot;, line 21, in _wrapped_function
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot.py&quot;, line 371, in apply_to_resolver
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot_basic_op.py&quot;, line 202, in apply_to_resolver
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot_basic_op.py&quot;, line 165, in test_resolver
  File &quot;T:\InGame\Gameplay\Scripts\Server\event_testing\tests.py&quot;, line 384, in run_tests
  File &quot;T:\InGame\Gameplay\Scripts\Server\event_testing\resolver.py&quot;, line 122, in __call__
  File &quot;T:\InGame\Gameplay\Scripts\Server\event_testing\resolver.py&quot;, line 613, in get_participants
ValueError: Trying to use SingleSimResolver with unsupported participant: ParticipantType.Invalid
</desyncdata>
</report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/authors/skillfulsimmer340ModsTest.js